import { DomSanitizer } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';
import { isNullOrUndefined } from '../../utils';

@Pipe({
    name: 'safeHtml',
    standalone: true
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private dom: DomSanitizer) {}
  transform(value) {
    if (isNullOrUndefined(value)) {
      return '';
    }
    return this.dom.bypassSecurityTrustHtml(value);
  }
}
